import { RowType } from '@cmps/ng-kit';

import { InsightsSummaryData } from '../coaching-insight/insight-widget/model/insights-summary-data.model';
import { CoachingInsightComponentAttributes } from '../coaching-insight/oa/models/coaching.global.model';
import { createAction } from '../store.model';

import { Mi2DataResult } from './models/mi2-data-result';
import { MyCoachingCard } from './models/my-coaching-card.model';
import { OaScoreType } from './models/oa-score-type.enum';
import { StagingKpiThreshold } from './models/staging-kpi-threshold.model';
import { WpCoachingCard } from './models/wp-coaching-card.model';

export enum ActionType {
    MY_COACHING_CARD__ROOT__RELOAD = 'MY_COACHING_CARD__ROOT__RELOAD',
    MY_COACHING_CARD__ROOT__RELOAD_RESULT = 'MY_COACHING_CARD__ROOT__RELOAD_RESULT',
    MY_COACHING_CARD_SELECT_PEER_GROUP = 'MY_COACHING_CARD_SELECT_PEER_GROUP',
    MY_COACHING_CARD_SET_CHART_DATA = 'MY_COACHING_CARD_SET_CHART_DATA',
    MY_COACHING_CARD_TOGGLE_SELECTED_ROW = 'MY_COACHING_CARD_TOGGLE_SELECTED_ROW ',
    MY_COACHING_CARD_CLOSE_ALL_CHARTS = 'MY_COACHING_CARD_CLOSE_ALL_CHARTS',
    MY_COACHING_CARD_ROOT__CLEAR_STATE = 'MY_COACHING_CARD_ROOT__CLEAR_STATE',
}

export interface Reload {
    periodTypeId: number;
    effectiveDate?: Date;
    startDate?: Date;
    endDate?: Date;
    userId: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.MY_COACHING_CARD__ROOT__RELOAD,
);

export interface ReloadResult extends Reload {
    coachingCard?: MyCoachingCard;
    coachingCardThreshold?: StagingKpiThreshold[];
    insightSummaryData?: InsightsSummaryData;
    componentAttributes?: CoachingInsightComponentAttributes;
    mi2DataResult?: Mi2DataResult;
    wpCoachingCard?: WpCoachingCard;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.MY_COACHING_CARD__ROOT__RELOAD_RESULT,
);
export interface SelectPeerGroup {
    selectedGroup?: OaScoreType;
    rowType?: RowType;
}

export const selectPeerGroup = createAction<ActionType, SelectPeerGroup>(
    ActionType.MY_COACHING_CARD_SELECT_PEER_GROUP,
);

export interface SetChartData {
    rowType: RowType;
    rowIndex: number;
}

export const setChartData = createAction<ActionType, SetChartData>(
    ActionType.MY_COACHING_CARD_SET_CHART_DATA,
);

export interface ToggleSelectedRow {
    rowIndex: number;
}

export const toggleSelectedRow = createAction<ActionType, ToggleSelectedRow>(
    ActionType.MY_COACHING_CARD_TOGGLE_SELECTED_ROW,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CloseAllCharts {}

export const closeAllCharts = createAction<ActionType, CloseAllCharts>(
    ActionType.MY_COACHING_CARD_CLOSE_ALL_CHARTS,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootClearStateAction {}

export const clearState = createAction<ActionType, RootClearStateAction>(
    ActionType.MY_COACHING_CARD_ROOT__CLEAR_STATE,
);
